import { render, staticRenderFns } from "./adduniUserChannel.vue?vue&type=template&id=66c7ff8e&scoped=true&"
import script from "./adduniUserChannel.vue?vue&type=script&lang=js&"
export * from "./adduniUserChannel.vue?vue&type=script&lang=js&"
import style0 from "./adduniUserChannel.vue?vue&type=style&index=0&id=66c7ff8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c7ff8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66c7ff8e')) {
      api.createRecord('66c7ff8e', component.options)
    } else {
      api.reload('66c7ff8e', component.options)
    }
    module.hot.accept("./adduniUserChannel.vue?vue&type=template&id=66c7ff8e&scoped=true&", function () {
      api.rerender('66c7ff8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginconfig/components/adduniUserChannel.vue"
export default component.exports